export const LIVEABOARD_DECK_OPTIONS = [
  "Lower deck",
  "Main deck",
  "Upper deck",
  "Sun deck",
  "Bridge deck",
] as const;

export const LIVEABOARD_CABIN_TYPES = [
  "TWIN",
  "DOUBLE",
  "TRIPLE",
  "QUAD",
  "SINGLE",
  "SUITE",
] as const;

export const LIVEABOARD_CURRENCY_CODES = [
  "EUR",
  "USD",
  "GBP",
  "THB",
  "AUD",
  "IDR",
  "PHP",
  "MXN",
] as const;

export const LIVEABOARD_HIGHLIGHT_OPTIONS = [
  "Free Nitrox",
  "En-suite cabins",
  "Aircon cabins",
  "Sun deck",
  "Snorkeller friendly",
  "Private charters",
  "Camera room",
  "Free Wi-Fi",
] as const;

export const LIVEABOARD_LANGUAGE_OPTIONS = [
  "English",
  "Spanish",
  "French",
  "German",
  "Italian",
  "Dutch",
  "Thai",
  "Indonesian",
  "Japanese",
  "Mandarin",
] as const;
